import React, { useState } from "react";
import Menu from "./Menu";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-scroll";

const Navbar = () => {
  const [mobileMenu, setMobileMenu] = useState(false);

  return (
    <nav className="flex gap-5 py-4 md:pr-16 md:pl-7 pr-4 pl-4 bg-tertiary fixed w-full z-10 top-0">
      <Link
        className="flex-auto my-auto text-3xl font-extrabold text-white cursor-pointer"
        to="home"
      >
        <div className="flex items-center gap-2">
          <img src="/icones/logo_w.png" alt="logo" className="w-[50px]" />
          <div>
            <span className="text-black">Study</span>cool
          </div>
        </div>
      </Link>

      <div className="hidden md:flex gap-5 items-center pr-20 text-base text-white">
        <Menu />
      </div>
      <div className="md:hidden flex items-center text-white ">
        <MenuIcon onClick={() => setMobileMenu(!mobileMenu)} />
      </div>
      {mobileMenu && (
        <div className="md:hidden absolute top-[100%] mt-2  left-0 right-0 flex flex-col justify-center  m-2 bg-primary p-4 w-[350px] gap-4 rounded-lg border-2 text-white">
          <Menu />
        </div>
      )}
    </nav>
  );
};

export default Navbar;
